import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import theme from "@shared/utils/themeColors";
import PaginationNumeric from "../../../shared/components/PaginationNumeric";
import { MemberCard } from "../components/MemberCard";
import { useMembers } from "../hooks/useMembers";

export default function Members() {
  const {
    members,
    isLoading,
    error,
    page,
    total,
    limit,
    handleSearch,
    handlePageChange,
    refresh,
  } = useMembers();

  return (
    <AuthenticatedLayout
      isLoading={isLoading}
      error={error ? new Error(error) : null}
      isEmpty={!members || members.length === 0}
      emptyStateProps={{
        title: "No members found",
        description: "There are no members to display",
        icon: (
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-t from-gray-200 to-gray-100 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`w-8 h-8 ${theme.text.muted}`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
              />
            </svg>
          </div>
        ),
      }}
      pageHeader={{
        title: "Members",
        search: {
          show: true,
          placeholder: "Search members...",
          onChange: handleSearch,
        },
        refresh: {
          show: true,
          onRefresh: refresh,
        },
      }}
    >
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        <div className="grid grid-cols-12 gap-6">
          {members.map((member) => (
            <div
              key={member.id}
              className="col-span-full sm:col-span-6 xl:col-span-3"
            >
              <MemberCard member={member} />
            </div>
          ))}
        </div>

        <div className="mt-8">
          <PaginationNumeric
            currentPage={page}
            totalPages={Math.ceil(total / limit)}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
